'use strict';

var _ = require('lodash');
var toastr = require('toastr');
function FareBasisGroupsGridController($scope, dataService, dataRetrieverService, dataRetrieverConstantsService) {
  $scope.gridId = 'fare-basis-groups';
  $scope.errorMessage = [];
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_BASIS_GROUPS_MODE).setCustomSearchCriteriaRules([]);
  $scope.refreshData = function () {
    $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
  };
  $scope.customSave = function (editRows) {
    return dataService.save(editRows).then($scope.refreshData);
  };
  $scope.customSaveErrorMessage = function (response) {
    if (response.status === 409) {
      toastr.error('Could not save duplicate documents.');
    } else {
      toastr.error('Can not able to save the current document.');
    }
  };
  function validateField(row, isValid, field) {
    if (!row[field]) {
      var humanizeField = _.chain(field).startCase().upperFirst().value();
      if (!$scope.errorMessage) {
        $scope.errorMessage = [];
      }
      $scope.errorMessage.push(humanizeField);
    }
    return isValid && !!row[field];
  }
  $scope.customSaveValidation = function (editRows) {
    var minimalFields = ['fareBasisGroup', 'fareBasisCodeMapping', 'priority'];
    var otherFields = ['journeyType', 'marketOrigin', 'marketDestination'];
    var isValid;
    $scope.errorMessage = [];
    for (var idx = 0; idx < editRows.length; idx++) {
      var row = editRows[idx];
      var fieldsToValidate = shouldEditAllFields(otherFields, row) && row.isNewlyAdded ? _.concat(minimalFields, otherFields) : minimalFields;
      isValid = _.reduce(fieldsToValidate, _.partial(validateField, row), true);
      if (!isValid) {
        break;
      }
    }
    return isValid;
  };
  function shouldEditAllFields(discrimitors, row) {
    return _.reduce(discrimitors, function (result, discriminator) {
      return result || _.get(row, discriminator, false);
    }, false);
  }
  $scope.customErrorMessage = function () {
    if (!_.size($scope.errorMessage)) {
      return;
    }
    return $scope.errorMessage.join(', ') + ' fields must not be empty.';
  };
  $scope.customRemove = function (editRows) {
    return dataService.remove(editRows).then($scope.refreshData);
  };
}
FareBasisGroupsGridController.$inject = ['$scope', 'FareBasisGroupsGridDataService', 'DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = FareBasisGroupsGridController;